import React, { createContext, useContext, useState, ReactNode } from "react";

type AppContextType = {
  token: any;
  setToken: (data: any) => void;
  purchaseOrder: any;
  setPurchaseOrder: (data: any) => void;
  photos: any;
  setPhotos: (data: any) => void;
  uploadWeightTicket: any;
  setUploadWeightTicket: (data: any) => void;
  delivery: any;
  setDelivery: (data: any) => void;
  loads: any;
  setLoads: (data: any) => void;
  loadItems: any;
  setLoadItems: (data: any) => void;
  salesOrder: any;
  setSalesOrder: (data: any) => void;
  meterialSo: any;
  setMeterialSo: (data: any) => void;
  materialfo: any;
  setMaterialfo: (data: any) => void;
  attachments: any;
  setAttachments: (data: any) => void;
  progressDeliveries: any;
  setProgressDeliveries: (data: any) => void;
};

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [purchaseOrder, setPurchaseOrder] = useState<any>(null);
  const [uploadWeightTicket, setUploadWeightTicket] = useState<any>(null);
  const [delivery, setDelivery] = useState<any>(null);
  const [token, setToken] = useState<any>(null);
  const [loads, setLoads] = useState<any>(null);
  const [loadItems, setLoadItems] = useState<any>(null);
  const [photos, setPhotos] = useState<any>([]);
  const [salesOrder, setSalesOrder] = useState<any>(null);
  const [meterialSo, setMeterialSo] = useState<any>(null);
  const [materialfo, setMaterialfo] = useState<any>(null);
  const [attachments, setAttachments] = useState<any>([]);
  const [progressDeliveries, setProgressDeliveries] = useState<any>(null);

  return (
    <AppContext.Provider
      value={{
        loads,
        setLoads,
        token,
        setToken,
        purchaseOrder,
        setPurchaseOrder,
        uploadWeightTicket,
        setUploadWeightTicket,
        delivery,
        setDelivery,
        loadItems,
        setLoadItems,
        photos,
        setPhotos,
        salesOrder,
        setSalesOrder,
        meterialSo,
        setMeterialSo,
        materialfo,
        setMaterialfo,
        attachments,
        setAttachments,
        progressDeliveries,
        setProgressDeliveries
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context)
    throw new Error("useAppContext must be used within AppProvider");
  return context;
};
